import { roundedClassname, roundedDropdownClassname } from '@/helpers/environmentHelper';
import { Menu, Transition } from '@headlessui/react';
import cn from 'classnames';
import { Fragment, ReactNode, useState } from 'react';

interface IDropDown {
    label?: string;
    button: ReactNode;
    className?: string;
    position?: 'left' | 'right';
    children: ReactNode | ((query: string) => ReactNode);
    searchable?: boolean;
    menuItemClassName?: string;
}

export const DropDown = ({
    label,
    button,
    className,
    position = 'right',
    children,
    searchable = false,
    menuItemClassName
}: IDropDown) => {
    const [query, setQuery] = useState('');

    return (
        <div className={cn(`flex z-20`, className)}>
            <Menu
                as="div"
                className={cn(
                    'relative inline-block text-left border border-brand-neutral-700 hover:border-brand-neutral-600 transition duration-150 bg-brand-background',
                    roundedClassname
                )}>
                <div className="relative flex items-center">
                    {label && (
                        <span className="pointer-events-none absolute -top-[8.5px] left-0.5 z-10 px-1.5 text-2xs font-bold text-brand-neutral-400 after:content-[''] after:absolute after:left-[2px] after:right-[2px] after:top-1/2 after:h-[1px] after:bg-brand-background after:-z-10">
                            {label}
                        </span>
                    )}
                    {button}
                </div>

                <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                    afterLeave={() => setQuery('')}>
                    <Menu.Items
                        className={cn(
                            `absolute w-full min-w-full whitespace-normal origin-top-right divide-y divide-white/10 pb-1 bg-brand-background-dark border border-brand-neutral-700 overflow-hidden`,
                            { [`${position}-0`]: true },
                            roundedDropdownClassname,
                            menuItemClassName
                        )}>
                        {searchable && (
                            <div
                                className="py-2 px-2 sticky top-0 bg-brand-background-dark z-10"
                                onClick={(e) => e.stopPropagation()}>
                                <input
                                    type="text"
                                    placeholder="Search..."
                                    value={query}
                                    onChange={(e) => setQuery(e.target.value)}
                                    className="w-full px-2 py-1 text-sm bg-brand-background-dark border border-brand-neutral-700 rounded outline-none text-brand-text placeholder:text-brand-neutral-400"
                                />
                            </div>
                        )}

                        {typeof children === 'function' ? children(query) : children}
                    </Menu.Items>
                </Transition>
            </Menu>
        </div>
    );
};
